module.exports = __webpack_public_path__ + "media/images/female-8130ca0f.png";